import { useEffect } from 'react';

const STORAGE_KEY = 'pendingGlobalSearch';

/**
 * Sayfalar bu hook'u kullanarak global aramadan gelen filtre terimini uygular.
 * Global aramada bir sonuca tıklandığında sessionStorage'a yazılır,
 * ilgili sayfa mount olunca buradan okuyarak searchTerm'i set eder.
 *
 * @param pageName - Bu sayfanın route adı (ör: 'gsm-lines', 'computers')
 * @param setSearchTerm - Sayfanın arama state setter'ı
 */
export function useGlobalSearch(pageName: string, setSearchTerm: (term: string) => void) {
  useEffect(() => {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    try {
      const { page, term } = JSON.parse(raw);
      if (page === pageName && term) {
        setSearchTerm(term);
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

/**
 * Global aramadan sayfaya yönlendirmeden önce çağrılır.
 * Sonraki sayfa mount'unda useGlobalSearch bu değeri okur.
 */
export function setPendingSearch(page: string, term: string) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ page, term }));
}
